
const Urls = {
    DELIVERY_SCHEDULE_URL: '/pillpack/settings/manage-future-deliveries',
    PAYMENT_PORTAL_URL: '/your-orders-api/command/get-payment-fixup-widget?gqlOrderId=',
    PAYMENT_REDIRECT_URL: '/your-orders-api/command/payment-redirect?gqlOrderId=',
    PILLPACK_SETTINGS: '/pillpack/settings'
}

export default Urls;